import { displayResultMessage } from "utils/misc";
import Input from "common/Inputs/Input";
import Form from "common/Form/Form";
import { RequestSource } from "@shared/types";
import { PrimaryTitle } from "features/auth/styles";
import React, { useState } from "react";
import useMedia from "utils/hooks/useMedia";
import { LOGIN_PATH, MOBILE_SEARCH } from "common/constants";
import { EMAIL_FORM_ITEM_RULES } from "features/auth/constants";
import Text from "common/Typography/Text";
import ResendEmailInstructions from "features/auth/ResendEmailInstructions";
import Flex from "common/Boxes/Flex";
import Button, { StyledDefaultButton } from "common/Buttons/Button";
import { useHistory } from "react-router-dom";
import Link from "common/Typography/Link";
import { sharedLib } from "@shared/services/shared.service";

const ForgotPasswordForm = () => {
  const history = useHistory();
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);

  const [email, setEmail] = useState<string>();
  const [showResendEmail, setShowResendEmail] = useState(false);
  const [showSupportLink, setShowSupportLink] = useState(false);

  const [forgotPassword, { isLoading }] =
    sharedLib.sharedApi.authentication.useForgotPasswordMutation();

  const onFinish = () => {
    if (email) {
      displayResultMessage(
        forgotPassword({
          email,
          request_source: RequestSource.WEBSITE,
        }).unwrap(),
        "Email successfully sent! We've sent you instructions to reset your password.",
        "Failed to send reset password email!",
        6
      ).catch(() => {});
    }
    setShowResendEmail(true);
    if (showResendEmail) setShowSupportLink(true);
  };

  return (
    <Form
      name="login"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      layout="vertical"
      requiredMark={false}
      style={{ textAlign: "center" }}
    >
      <PrimaryTitle $isMobile={isMobile} style={{ marginBottom: 16 }}>
        Forgot Your Password?
      </PrimaryTitle>
      <Text style={{ marginBottom: 24 }}>
        Enter the email address that you registered with and we will send you
        further instructions.
      </Text>
      <Form.Item
        label="Email"
        name="email"
        rules={EMAIL_FORM_ITEM_RULES}
        style={{ textAlign: "start" }}
      >
        <Input size="large" onChange={(e) => setEmail(e.target.value)} />
      </Form.Item>
      <Flex
        $justifyContent="center"
        style={{ width: "100%", columnGap: 16, marginTop: 16 }}
      >
        <StyledDefaultButton
          $size="l"
          onClick={() => history.push(LOGIN_PATH)}
          style={{ width: "100%" }}
        >
          Back to Login
        </StyledDefaultButton>
        <Button
          type="primary"
          $size="l"
          htmlType="submit"
          loading={isLoading}
          disabled={!email}
          style={{ width: "100%" }}
        >
          Reset Password
        </Button>
      </Flex>
      {showResendEmail && (
        <div style={{ marginTop: 12 }}>
          <Link onClick={onFinish}>Resend Email</Link>
        </div>
      )}
      {showSupportLink && <ResendEmailInstructions addBorder={true} />}
    </Form>
  );
};

export default ForgotPasswordForm;
